<template>
  <div class="product-list-item" :class="{ 'cart-mode': cartMode, 'is-catalog': isCatalog, [`sku--${product.sku}`]: 1 }">

    <h3 class="page-title text-center">{{ title }}</h3>
    <div :class="wrapperClasses">
      <div class="product" :class="extraClasses">

        <!-- show product detail -->
        <!-- <div class="product__block product__block--form mt-15"> -->
        <div class="product__block--form">
          <product-donate-type v-model="donateType" :product="product" @input="updateDonateType" />
          <div class="block-border radius block">
            <product-donate-choice
                    ref="donateChoice"
                    :show-donate-type="false"
                    :product="product"
                    :choices="donateConfig.choices"
                    :choiceDescriptions="donateConfig.descriptions"
                    :minimum="20"
                    :defaultAmount="donateConfig.default"
                    :classes="donateChoiceClasses" />

            <div class="text-center" v-if="$utils.isDailyOptionEnabled() && allowedMonthly && $store.state.donateType === 'monthly'">
              <label class="form-check-label">
                <input v-model="forceDaily" type="checkbox" class="form-check-input" style="position: static;left:0" /> [Testing] Force recurring period to daily
              </label>
            </div>

            <!-- for Sandbox project -->
            <div v-if="product.sku === 'edusandbox'" class="sandbox-provinces-select-wrapper">
              <select class="form__input text-left sandbox-provinces-select" v-model="selectedSandboxProvince" required>
                <option v-for="p in sandboxProvinces" :key="p.value" :value="p.value">{{ p.name }}</option>
              </select>
            </div>
            
            <!-- <donor-info class="mt-5" v-model="choices.info.name" /> -->

            <div class="text-center my-4">
              <product-cart-action
                      :stockAvailable="stockAvailable"
                      :attributes="choices"
                      v-show="!cartMode"
                      :product="product"
                      :initialQuantity="initialQuantity"
                      @resetQuantity="resetQuantity"
                      :addToCartButton="false"
                      :buyNowButton="false"
                      :style="{margin:0}"
                      ref="cartAction" />

              <product-cart-action
                class="hidden"
                :stockAvailable="stockAvailable"
                :attributes="choices"
                v-show="!cartMode"
                :product="productEduSandbox"
                :initialQuantity="initialQuantity"
                @resetQuantity="resetQuantity"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartActionEduSandbox" />

              <button type="button" class="btn btn--purple btn-md" @click.prevent="donate">บริจาค</button>
            </div>
            <div class="text-center mb-2 mt-3 mt-md-4" style="">
              <div class="remark-badge">ข้อมูลการบริจาคจะส่งไปยังสรรพากร ผ่าน e-Donation</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCartForm from './ProductCartForm.vue'
import ProductCartAction from './ProductCartAction.vue'
import ProductChoice from './ProductChoice.vue'
import ProductChoiceSummary from './ProductChoiceSummary.vue'
import ProductDonateChoice from './ProductDonateChoice.vue'
import ProductDonateType from './ProductDonateType.vue'
import DonorInfo from './DonorInfo.vue'

export default {
  components: {
    DonorInfo,
    ProductChoiceSummary,
    ProductCartAction,
    ProductCartForm,
    ProductChoice,
    ProductDonateChoice,
    ProductDonateType
  },
  name: 'ProductListItem',
  props: {
    product: {
      type: Object,
      required: true
    },
    initialQuantity: {
      type: Number,
      required: true
    },
    cartMode: {
      type: Boolean,
      required: false
    },
    showAttributes: {
      type: Boolean,
      required: false
    },
    useCarousel: {
      type: Boolean,
      required: false,
      default: false
    },
    titleAsLink: {
      type: Boolean,
      required: false,
      default: true
    },
    extraClasses: {
      type: String,
      required: false,
      default: ''
    },
    showTimeBeforeAvailable: {
      type: Boolean,
      required: false,
      default: false
    },
    forceNoActions: {
      type: Boolean,
      required: false,
      default: false
    },
    initialChoices: {
      type: Object,
      required: false
    }
  },
  data () {
    let choices = this.initialChoices || {info: {name: '', utm_source: ''}}
    const utmSource = window.location.search.match(/utm_source=(\w+)/)
    if (utmSource) {
      choices.info = Object.assign({}, choices.info, {name: '', utm_source: ''})
      choices.info['utm_source'] = utmSource[1]
    }

    let productEduSandbox = null
    if (this.product.sku.startsWith('edusandbox')) {
      productEduSandbox = this.product
    }

    return {
      quantity: this.initialQuantity,
      timeBeforeAvailable: 0,
      stockAvailable: false,
      stockChecking: false,
      stockQuantity: 0,
      choices: choices,
      showPageSelector: false,
      donateChoiceClasses: '',
      wrapperClasses: '',
      showDonateType: false,
      donateType: this.$store.state.donateType || 'onetime',
      title: '',
      donateData: {
        onetime: {
          choices: [],
          descriptions: [],
          customAmount: null,
          default: 0
        },
        monthly: {
          choices: [],
          descriptions: [],
          customAmount: null,
          default: 0
        }
      },
      forceDaily: false,
      sandboxProvinces: [
        {name: 'ไม่ระบุจังหวัด', value: ''},
        {name: 'กระบี่', value: 'krabi'},
        {name: 'กรุงเทพมหานคร', value: 'bangkok'},
        {name: 'กาญจนบุรี', value: 'kanchanaburi'},
        {name: 'จันทบุรี', value: 'chanthaburi'},
        {name: 'เชียงใหม่', value: 'chiangmai'},
        {name: 'ตราด', value: 'trat'},
        {name: 'นราธิวาส', value: 'narathiwat'},
        {name: 'บุรีรัมย์', value: 'buriram'},
        {name: 'ปัตตานี', value: 'pattani'},
        {name: 'ภูเก็ต', value: 'phuket'},
        {name: 'แม่ฮ่องสอน', value: 'maehongson'},
        {name: 'ยะลา', value: 'yala'},
        {name: 'ระยอง', value: 'rayong'},
        {name: 'ศรีสะเกษ', value: 'sisaket'},
        {name: 'สงขลา', value: 'songkhla'},
        {name: 'สตูล', value: 'satun'},
        {name: 'สระแก้ว', value: 'sakaeo'},
        {name: 'สุโขทัย', value: 'sukhothai'},
        {name: 'สุราษฎร์ธานี', value: 'suratthani'},
        {name: 'อุบลราชธานี', value: 'ubonratchathani'}
      ],
      selectedSandboxProvince: '',
      productEduSandbox: productEduSandbox
    }
  },
  created () {
    this.stockAvailable = false
    if (this.isStockProductType) {
      if (this.product.stockAttributes && !this.initialChoices) {
        for (let item of this.product.stockAttributes) {
          this.choices[item.key] = item.attributes[0]
        }
      }
    }

    let t = setInterval(() => {
      this.timeBeforeAvailable = this.$utils.timeBeforeProductAvailable(this.product)
      if (this.timeBeforeAvailable <= 0) {
        clearInterval(t)
        if (this.isStockProductType) {
          this.checkStock()
        }
      }
    }, 1000)

    this.product.originalPrice = this.product.price

    this.$utils.setBodyClasses('product-page')

    if (this.$route.query.type === 'monthly') {
      this.title = 'การบริจาครายเดือนจะช่วยให้น้องๆ ที่ขาดโอกาสสามารถเข้าถึงการศึกษาได้มากขึ้น'
    }

    this.initDonateData()
    this.$store.dispatch('initDonateType').then(() => {
      this.donateType = (this.allowedMonthly && this.$store.state.donateType) || 'onetime'
      if (!this.$utils.isMonthlyOptionAllowed() && this.$store.state.donateType === 'monthly') {
        this.$store.dispatch('setDonateType', 'onetime')
      }
      this.forceDaily = this.$store.state.forceDaily
    })
  },
  computed: {
    firstImage () {
      return this.images[0]
    },
    images () {
      return this.$utils.processProductImages(this.product)
    },
    shippingFee () {
      if (this.product.shippingGroup) {
        return 0
      }
      return this.$utils.shippingFee(this.product, this.quantity)
    },
    isSoldout () {
      return (this.product.flags & 1) || (this.product.notAfter && this.product.notAfter < (new Date()).getTime())
    },
    isComingSoon () {
      return (this.product.flags & 2)
    },
    isCatalog () {
      return this.product.type === this.$const.PRODUCT_TYPES.CATALOG
    },
    showCountdownTimer () {
      return this.showTimeBeforeAvailable && (this.timeBeforeAvailable && this.timeBeforeAvailable >= 0)
    },
    isStockProductType () {
      return this.product.type === this.$const.PRODUCT_TYPES.STOCK
    },
    isDonateProductType () {
      return this.product.type === this.$const.PRODUCT_TYPES.DONATE
    },
    donateConfig () {
      return this.donateData[(this.allowedMonthly && this.$store.state.donateType) || 'onetime'] || {choices: [], default: 0, customAmount: null}
    },
    allowedMonthly () {
      if (!this.$utils.isMonthlyOptionAllowed()) return false
      return this.product.meta.$donation_allow_recurring_donation === true || this.product.meta.$donation_allow_recurring_donation === 'true'
    }
  },
  methods: {
    initDonateData () {
      if (this.product.meta.$donation_onetime_amount_options) {
        const defs = JSON.parse(this.product.meta.$donation_onetime_amount_options || '[]')
        this.donateData.onetime.choices = defs.map(it => parseInt(it[0]))
        this.donateData.onetime.descriptions = defs.map(it => it[1])
      }
      if (this.product.meta.$donation_onetime_amount_options_default_amount) {
        this.donateData.onetime.default = parseInt(this.product.meta.$donation_onetime_amount_options_default_amount)
      }
      this.donateData.onetime.customAmount = true

      if (this.product.meta.$donation_recurring_amount_options) {
        const defs = JSON.parse(this.product.meta.$donation_recurring_amount_options || '[]')
        this.donateData.monthly.choices = defs.map(it => parseInt(it[0]))
        this.donateData.monthly.descriptions = defs.map(it => it[1])
      } else {
        this.donateData.monthly.choices = this.donateData.onetime.choices
      }
      if (this.product.meta.$donation_recurring_amount_options_default_amount) {
        this.donateData.monthly.default = parseInt(this.product.meta.$donation_recurring_amount_options_default_amount)
      } else if (this.donateData.onetime.default) {
        this.donateData.monthly.default = this.donateData.onetime.default
      }
      this.donateData.monthly.customAmount = true
    },
    donate () {
      this.$utils.ensure(this.$refs, 'donateChoice')
        .then(async () => {
          this.product.price = this.$refs.donateChoice.getPrice()

          if (!this.$refs.donateChoice.validate()) {
            return
          }

          if (this.product.sku.startsWith('edusandbox') && this.selectedSandboxProvince) {
            const provinceCode = this.selectedSandboxProvince.toLowerCase()
            const newSku = 'edusandbox-' + provinceCode

            try {
              const resp = await this.$http.get(`products/${newSku}`)
              this.productEduSandbox = resp.body
              this.productEduSandbox.price = this.$refs.donateChoice.getPrice()

              this.$store.dispatch('clearCart').then(() => {
                this.$refs.cartActionEduSandbox.buyNow()
              })
            } catch (e) {
              // TODO: alert
            }
          } else {
            this.$store.dispatch('clearCart').then(() => {
              this.$refs.cartAction.buyNow()
            })
          }
        })
    },
    catalogName (product) {
      const catalog = this.$store.state.products[product.catalogSku]
      return (catalog && catalog.name) || ''
    },
    updateValue (product, attributes, value) {
      const parsedValue = parseInt(value || 0)
      this.quantity = parsedValue
      this.$refs.cartAction.setQuantity(parsedValue)
      this.$emit('quantityChanged', product, attributes, parsedValue)

      this.stockAvailable = this.quantity <= this.stockQuantity
    },
    checkStock (showModal) {
      this.stockChecking = true
      if (showModal) {
        this.$modal.show({
          title: 'กรุณารอสักครู่',
          text: 'กำลังตรวจสอบรายการ ...',
          okButton: false
        })
      }

      let configSku = this.$utils.getProductConfigSku(this.product, this.choices)
      this.$http.get(`inventories/check/${configSku}`)
        .then(resp => {
          setTimeout(() => {
            this.stockChecking = false
            this.$modal.hide()
          }, 500)
          if (resp.body.item) {
            this.stockQuantity = resp.body.item.quantity || 0
          } else {
            this.stockQuantity = 0
          }
          this.stockAvailable = this.quantity <= this.stockQuantity
        })
        .catch(err => {
          console.log(err)
          setTimeout(() => {
            this.stockChecking = false
            this.$modal.hide()
          }, 500)
          this.stockAvailable = false
        })
    },
    resetQuantity () {
      this.quantity = 1
      if (this.$refs.cartForm) {
        this.$refs.cartForm.resetQuantity()
      }
      this.$emit('quantityChanged', this.product, 1)
    },
    itemRemoved (product, attributes, quantity) {
      this.$emit('itemRemoved', product, attributes, quantity)
    },
    attrChanged (choices) {
      this.choices = Object.assign({}, choices)
      setTimeout(() => {
        this.checkStock()
      }, 100)
    },
    updateDonateType (t) {
      this.donateType = t || 'oneway'
      this.$store.dispatch('setDonateType', this.donateType)
    }
  },
  watch: {
    forceDaily: function (newVal) {
      this.$store.dispatch('setForceDaily', newVal)
    }
  }
}
</script>

<style scoped lang="scss">
  .text-muted.-count-down {
    color: red;
  }
  .donate__wrapper {
    margin: 20px 0 0;

    button {
      width: 100%;
    }
  }
  .page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .sandbox-provinces-select-wrapper {
    // margin: 0 82px;
    max-width: 400px;
    margin: 0 auto 30px;
  }
  .sandbox-provinces-select {
    font-size: 1.15rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 12px 15px;
    border-radius: 8px;

  }

  select.sandbox-provinces-select {
    /* reset */
    margin: 0;      
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    
    /* style */
    background-image:
      linear-gradient(45deg, transparent 50%, gray 50%),
      linear-gradient(135deg, gray 50%, transparent 50%),
      linear-gradient(to right, #ccc, #ccc);
    background-position:
      calc(100% - 30px) calc(1em + 2px),
      calc(100% - 20px) calc(1em + 2px),
      calc(100% - 3em) 0.5em;
    background-size:
      10px 10px,
      10px 10px,
      1px 1.5em;
    background-repeat: no-repeat;
  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
  &:focus {
      background-image:
        linear-gradient(45deg, #153050 50%, transparent 50%),
        linear-gradient(135deg, transparent 50%, #153050 50%),
        linear-gradient(to right, #ccc, #ccc);
      background-position:
        calc(100% - 20px) 1em,
        calc(100% - 30px) 1em,
        calc(100% - 3em) 0.5em;
      background-size:
        10px 10px,
        10px 10px,
        2px 1.5em;
      background-repeat: no-repeat;
      border-color: #153050;
      outline: 0;
    }
  }

</style>

<style>
  .VueCarousel-inner {
    align-items: center;
    min-height: 300px;
  }
  .VueCarousel-slide { text-align: center !important;}
  .VueCarousel-dot {
    padding: 2px 4px !important;
  }
  .VueCarousel-dot-inner {
    background: #fff !important;
    border: 1px solid #9D77BA !important;
  }
  .VueCarousel-dot--active .VueCarousel-dot-inner {
    background: #9D77BA !important;
  }
</style>



// WEBPACK FOOTER //
// ProductListItem.vue?2233d4c5